export type RewardCurrency = Readonly<{
  code: string;
  /** Emoji flag shown next to the code in the picker. */
  flag: string;
  /** Symbol prefixed to the per-star monetary value. */
  symbol: string;
  /** Monetary value of a single star in this currency (USD is the base = 1). */
  starValue: number;
}>;

export const REWARD_CURRENCIES: ReadonlyArray<RewardCurrency> = [
  { code: "USD", flag: "🇺🇸", symbol: "$", starValue: 1 },
  { code: "CHF", flag: "🇨🇭", symbol: "CHF", starValue: 0.8 },
  { code: "BDT", flag: "🇧🇩", symbol: "৳", starValue: 122 },
  { code: "BTN", flag: "🇧🇹", symbol: "Nu.", starValue: 84 },
];

export const DEFAULT_REWARD_CURRENCY = "USD";

export const getRewardCurrency = (code: string): RewardCurrency =>
  REWARD_CURRENCIES.find((c) => c.code === code) ?? REWARD_CURRENCIES[0];
